export enum NexioEventType {
  Loaded = 'loaded',
  ErrorEvent = 'error',
  CardSavedEvent = 'cardSaved',
  FromValidationEvent = 'formValidations',
}
